import script from "./LicenceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenceInfo.vue?vue&type=script&setup=true&lang=js"

import "./LicenceInfo.vue?vue&type=style&index=0&id=c5d4091a&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5d4091a"]])

export default __exports__